module.exports = __webpack_public_path__ + "img/ph_3.3175f51f.jpg";